export const isCancelError = (error: any) => {
  return (
    error &&
    typeof error === 'object' &&
    (('errorMessage' in error && error.errorMessage === 'Share canceled') ||
      ('message' in error && error.message === 'Share canceled'))
  );
};
